<div class="job-management-container">
  <div class="job-header">
    <h2 class="job-title">{{ displayTitle }}</h2>

    <div class="progress-bar-container">
      <div class="progress-bar-wrapper">
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            [style]="getProgressBarStyle()"
            [class.accelerating]="overallProgress > 50"
          ></div>
          <div class="progress-stripes"></div>
        </div>
        <div class="step-markers">
          <div 
            *ngFor="let marker of stepMarkers; let i = index" 
            class="step-marker"
            [class.active]="isMarkerActive(i)"
            [class.completed]="isMarkerCompleted(i)"
            [style.left]="marker.position"
          >
            <div class="marker-triangle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="steps-container">
    <div 
      *ngFor="let step of steps; let i = index; let isLast = last" 
      class="step-item"
      [class.active]="step.status === 'in_progress'"
      [class.completed]="step.status === 'completed'"
      [class.pending]="step.status === 'pending'"
      [class.is-last]="isLast"
    >
      <div class="step-header" (click)="toggleStep(step)">
        <div class="step-indicator">
          <div class="step-ring" [class.pulsating]="step.status === 'in_progress'">
            <span *ngIf="step.status === 'completed'" class="checkmark">✓</span>
            <span *ngIf="step.status === 'in_progress'" class="step-number">{{ i + 1 }}</span>
            <span *ngIf="step.status === 'pending'" class="step-number">{{ i + 1 }}</span>
          </div>
        </div>
        
        <div class="step-content">
          <div class="step-title-row">
            <span class="step-title">{{ step.title }}</span>
            <span class="milestone-count" *ngIf="step.status !== 'pending' && getVisibleMilestonesCount(step) > 0">
              {{ getCompletedMilestonesCount(step) }}/{{ getVisibleMilestonesCount(step) }}
            </span>
            <span class="expand-icon" [class.expanded]="step.expanded">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="2" fill="none"/>
              </svg>
            </span>
          </div>
          <p class="step-description" *ngIf="step.status === 'in_progress'">
            {{ step.description }}
          </p>
          
          <div class="milestones-list" [class.expanded]="step.expanded" *ngIf="step.status !== 'pending'">
            <div 
              *ngFor="let milestone of step.milestones" 
              class="milestone-item"
              [class.completed]="milestone.status === 'completed'"
              [class.in-progress]="milestone.status === 'in_progress'"
              [class.pending]="milestone.status === 'pending'"
              [class.hidden]="!milestone.visible"
            >
              <span class="milestone-icon">
                <svg *ngIf="milestone.status === 'completed'" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6L5 9L10 3" stroke="#7C3AED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="milestone.status === 'in_progress'" width="12" height="12" viewBox="0 0 12 12" fill="none" class="spinner">
                  <circle cx="6" cy="6" r="4" stroke="#7C3AED" stroke-width="2" stroke-dasharray="3 2" fill="none"/>
                </svg>
                <span *ngIf="milestone.status === 'pending'" class="pending-dash">–</span>
              </span>
              <span class="milestone-label">{{ milestone.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="job-footer">
    <div class="time-estimate">
      <span class="time-value">{{ timeEstimateDisplay }}</span>
    </div>
    
    <div class="action-buttons">
      <button type="button" class="btn-background" (click)="onRunInBackground($event)">
        <span class="play-icon">▶</span>
        Run in background
      </button>
      <a class="btn-cancel-link" (click)="onCancel()">Cancel</a>
    </div>
  </div>
</div>
